export const USERS = 'users';
export const USER = 'user';
export const TASKS = 'tasks';
export const CATEGORIES = 'categories';
export const CONTENTS = 'contents';
export const VIDEOS = 'videos';
export const NOTIFICATIONS = 'notificationsHistory';
